<template>
    <div>
        <div class="mb-3 flex justify-end gap-x-5">
            <hts-form-button
                color="main"
                icon-name="hi-plus-circle-icon"
                icon-position="right"
                type="submit"
                @click="openFormAdd">
                {{ $t('labels.addLocation') }}
            </hts-form-button>
        </div>

        <hts-data-table
            ref="dataTables"
            view-deleted
            :headers="header"
            :server="server"
            :use-archive="useLocationArchive"
            :use-restore="useLocationRestore"
            use-selection
            :pagination="true"
            store-name="nodeDataTable"
            store-key="NodeLocation" />

        <add-location
            ref="addLocation"
            @refresh-tables="refreshTables()" />

        <detail-location
            ref="detailLocation"
            @refresh-tables="refreshTables()" />

        <hts-modal
            :show="openDelete"
            :title="$t('labels.deleteLocation')"
            type="confirm"
            :content="$t('labels.confirmDeleteLocation')"
            @close="closeDelete"
            @confirm="() => actionDelete()" />
    </div>
</template>
<script setup lang="ts">
import AddLocation from './location/ignore/add.vue'
import DetailLocation from './location/ignore/detail.vue'
import { $urlSystem } from '#imports'

const { $formatters } = useNuxtApp()
const { $t } = useNuxtApp()
const server = ref({ ...$urlSystem.node.location.list })

const addLocation = ref()
const detailLocation = ref()
const dataTables = ref()
const locationDelete = ref<{ [key: string]: any }>({})
const openDelete = ref(false)
const viewNodeLocationArchive = ref(false)

const handleViewNodeLocationArchive = (action: boolean) => {
  viewNodeLocationArchive.value = action
  server.value.method = $urlSystem.node.location.list.method
  server.value.url = $urlSystem.node.location.list.url.replace('ARCHIVE', String(action))
  nextTick(() => {
    if (dataTables.value) {
      dataTables.value.refresh()
    }
  })
}

const openFormAdd = () => {
  if (addLocation?.value) {
    addLocation?.value.open()
  }
}

const refreshTables = () => {
  if (dataTables.value) {
    dataTables.value.refresh()
  }
}

const handleView = (location: any) => {
  if (detailLocation?.value) {
    detailLocation?.value.open(location._id)
  }
}

const handleDelete = (deleteOptions: { [key: string]: any }) => {
  if (deleteOptions && deleteOptions._id) {
    locationDelete.value = {
      selectedItems: [deleteOptions._id]
    }
  } else {
    locationDelete.value = deleteOptions
  }
  openDelete.value = true
}

const closeDelete = () => {
  locationDelete.value = {}
  openDelete.value = false
}

const actionDelete = () => {
  const api = $urlSystem.node.location.delete

  $api(api, { body: locationDelete.value }).then((data: any) => {
    const resData: any = data.data.value
    if (resData.success) {
      process.client && $toast().success($t('labels.deleteSuccess'))

      closeDelete()
      refreshTables()
    }
  })
}

const handleActionArchive = (location: any) => {
  locationDelete.value = location._id
  actionDelete()
}

const header = computed(() => [
  {
    field: 'address',
    headerName: $t('labels.address'),
    sortable: true,
    filter: 'agTextColumnFilter'
  },
  {
    field: 'locationName',
    headerName: $t('labels.locationName'),
    sortable: true,
    filter: 'agTextColumnFilter'
  },
  {
    field: 'placeId',
    headerName: 'Loại địa điểm',
    sortable: true,
    valueGetter: (params: any): string => {
      const newLocation = params.data.newLocation
      if (!newLocation) {
        return 'Kế thừa từ google Maps'
      }
      return 'Tạo mới'
    }
  },
  {
    field: 'lat',
    headerName: $t('labels.latitudeAndLongitude'),
    sortable: true,
    filter: 'agTextColumnFilter',
    valueGetter: (params: any): string => {
      const placeId = params.data.placeId

      return `${params.data.lat}, ${params.data.lng}`
    }
  },
  {
    field: 'createdAt',
    headerName: $t('labels.createdAt'),
    maxWidth: 200,
    sortable: true,
    filter: 'agDateColumnFilter',
    valueGetter: (params: any) => {
      return $formatters.datetime(params.data.createdAt)
    }
  },
  {
    field: 'updatedAt',
    headerName: $t('labels.updatedAt'),
    maxWidth: 200,
    sortable: true,
    filter: 'agDateColumnFilter',
    valueGetter: (params: any) => {
      return $formatters.datetime(params.data.updatedAt)
    }
  },
  {
    field: 'action',
    pinned: 'right',
    sortable: false,
    lockPosition: true,
    lockPinned: true,
    popup: true,
    suppressRowTransform: true,
    suppressMenu: true,
    resizable: false,
    headerName: $t('labels.action'),
    cellStyle: { overflow: 'visible' },
    cellRenderer: 'Actions',
    cellRendererParams: {
      storeKey: 'nodeDataTable',
      storeName: 'NodeLocation',
      items: [
        {
          icon: 'hi-eye-icon',
          label: $t('labels.viewDetail'),
          class: 'text-blue-600 hover:text-blue-500',
          permissions: !viewNodeLocationArchive.value,
          isAll: true,
          click: handleView
        },
        {
          icon: 'hi-trash-icon',
          label: $t('labels.delete'),
          class: 'text-error-600 hover:text-error-500',
          permissions: !viewNodeLocationArchive.value,
          isArchive: true,
          click: handleDelete
        }
      ]
    }
  }
])

const useLocationArchive = computed(() => {
  return {
    api: $urlSystem.node.location.archive,
    permissions: true
  }
})
const useLocationRestore = computed(() => {
  return {
    api: $urlSystem.node.location.restore,
    permissions: true
  }
})
</script>
